import { useRouter } from "next/router";

const useGoBack = (defaultRoute?: string) => {
  const router = useRouter();

  const goBackHandler = () => {
    if (window.history.length > 1) {
      const currentUrl = window.location.pathname;
      const prevUrl = document.referrer
        ? new URL(document.referrer).pathname
        : null;

      if (prevUrl === currentUrl) {
        router.push(defaultRoute || "/");
      } else {
        router.back();
      }
    } else {
      router.push(defaultRoute || "/");
    }
  };

  return goBackHandler;
};

export default useGoBack;
